import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Table, Pagination } from 'react-bootstrap';
import { AnchorComponent } from "../../elements";

export default function ProductCreatorProductsTableComponent({ thead, tbody }) {
    const { t } = useContext(TranslatorContext);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    useEffect(() => {
        setData(tbody || []);
        setCurrentPage(1);
    }, [tbody]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="table-responsive w-100" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            <Table className="mc-table product align-middle mb-0" hover style={{ minWidth: "950px" }}>
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => (
                            <th key={index} className="text-nowrap">{t(item)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {currentData && currentData.length > 0 ? (
                        currentData.map((item, index) => {
                            const pImage = item?.card_img ? `${process.env.REACT_APP_IMG_URL}${item.card_img}` : "";
                            const pTitle = item?.title || "N/A";
                            const pDescribe = item?.selling_style || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const style = item?.selling_style || "N/A";

                            const pCategory = typeof item?.category === "object" ? item?.category?.name : (item?.category || "N/A");
                            const pBrand = typeof item?.brand === "object" ? item?.brand?.name : (item?.brand || "N/A");
                            const pricePresent = item?.sell_price_dollar || 0;

                            return (
                                <tr key={item?.id || index}>
                                    <td className="align-middle" style={{ width: "160px", minWidth: "160px" }}>
                                        <span>{pCode}</span>
                                    </td>
                                    <td className="align-middle" style={{ width: "220px", minWidth: "220px" }}>
                                        <div className="mc-table-product md d-flex align-items-center gap-2">
                                            {pImage && <img src={pImage} alt={pTitle} style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px", flexShrink: 0 }} />}
                                            <div className="mc-table-group" style={{ overflow: "hidden" }}>
                                                <h6 className="mb-0 text-truncate" title={pTitle}>{pTitle}</h6>
                                                <p className="mb-0 text-muted small text-truncate">{pDescribe}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="align-middle" style={{ width: "180px", minWidth: "180px" }}>
                                        <div className="d-flex flex-column text-break" style={{ fontSize: "13px", lineHeight: "1.4" }}>
                                            <span><strong>{t("Category")}:</strong> {pCategory}</span>
                                            <span><strong>{t("Brand")}:</strong> {pBrand}</span>
                                            <span><strong>{t("Style")}:</strong> {style}</span>
                                        </div>
                                    </td>
                                    <td className="align-middle text-nowrap" style={{ width: "110px", minWidth: "110px" }}>
                                        <p className="mb-0 fw-semibold text-success">${pricePresent}</p>
                                    </td>
                                    <td className="align-middle text-nowrap" style={{ width: "140px", minWidth: "140px" }}>
                                        <div className="mc-table-action d-flex align-items-center gap-2">
                                            <AnchorComponent
                                                to={`/product-creator/products/${item.id}/edit`}
                                                state={{ item }}
                                                title="Edit"
                                                className="material-icons edit"
                                            >
                                                edit
                                            </AnchorComponent>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 5} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {totalPages > 1 && (
                <div className="d-flex justify-content-end mt-4 px-3">
                    <Pagination>
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                        {[...Array(totalPages)].map((_, index) => {
                            const pageNum = index + 1;
                            return (
                                <Pagination.Item key={pageNum} active={pageNum === currentPage} onClick={() => handlePageChange(pageNum)}>
                                    {pageNum}
                                </Pagination.Item>
                            );
                        })}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                </div>
            )}
        </div>
    );
}